export default [
  {
    path: '/audit/logs',
    name: 'audit-logs',
    component: () => import('@/views/audit/AuditLogs.vue'),
    meta: {
      resource: 'system',
      action: ['read', 'update'],
      pageTitle: 'Audit Log',
      breadcrumb: [
        { text: 'หน้าแรก', to: '/' },
        { text: 'Audit Log', active: true },
      ],
    },
  },
]
